import { NgModule, APP_INITIALIZER } from '@angular/core';
import { T4CommonModule } from '../../t4common/t4common';
import { ServiceComponent } from './Components/Service/Service';
import { T4_FindIssueDialog } from './dialogs/findIssueDialog/findIssueDialog';
import { IssueNoteDialog } from './dialogs/issueNoteDialog/issueNoteDialog';
import { T4_ServiceDialog } from './dialogs/serviceDialog/serviceDialog';
import { CommonModule } from '@angular/common';
import { AuthGuard, T4coreModule, UIService } from 't4core';
import { ContactInfoDialog } from './dialogs/contactInfoDialog/contactInfoDialog';
import { ServiceGuysComponent } from './Views/ServiceGuys/ServiceGuys.component';
import { RouterModule } from '@angular/router';
import { MatGridListModule } from '@angular/material/grid-list';
import { ServiceGuyDialog } from './dialogs/serviceGuyDialog/serviceGuyDialog';
import { EnumStatusPipe, SecurityCheckDashboardComponent } from './Views/SecurityCheck/SecurityCheckDashboard.component';
import { SecurityCheckInfoDialog } from './dialogs/secutiyCheckInfoDialog/securityCheckInfoDialog';
import { MatSortModule } from '@angular/material/sort';
import { UpdateStockDialog } from './dialogs/updateStockDialog/updateStockDialog';
import { ServiceGuysTypesViewComponent } from './Views/ServiceGuyTypes/ServiceGuysTypesView';
import { ServiceGuyTypeDialog } from './dialogs/serviceGuyTypeDialog/serviceGuyTypeDialog';
import { ServiceGuyItemsDashboardComponent } from './Views/ServiceGuyItems/ServiceGuyItemsDashboard.component';
import { InventoryStatus } from './Views/InventoryStatus/InventoryStatusDashboard.component';
import { ItemDialog } from './dialogs/ItemDialog/ItemDialog';
import { AssetsDashboardComponent } from './Views/Assets/AssetsDashboard.component';
import { AssetInformationDialog, BatteryPipeNoke } from './dialogs/assetInformationDialog/assetInformationDialog';
import { SelectServiceGuyDialog } from './dialogs/selectServiceGuyDialog/selectServiceGuyDialog';

import { PerformedInspectionsComponent } from './Views/Reports/PerformedInspections/PerformedInspections';
import { BluetoothLocks } from './Views/Reports/BluetoothLocks/BluetoothLocks.component';
import { DetachedBluetoothLocks } from './Views/Reports/DetachedBluetoothLocks/DetachedBluetoothLocks.component';
import { TransferSummaryDialog } from './dialogs/transferSummaryDialog/transferSummaryDialog';
import { AddActionDialog } from './dialogs/addActionDialog/addActionDialog';
import { RentalObjectListComponent } from './Views/RentalObjectList/rentalObjectList';
import { PdfServiceDialog } from './dialogs/pdfServiceDialog/pdfServiceDialog';
import { ServiceMessageDialogDialog } from './dialogs/serviceMessageDialog/serviceMessageDialog';

@NgModule({
    declarations: [
        ServiceComponent,
        T4_ServiceDialog,
        T4_FindIssueDialog,
    IssueNoteDialog,
    BatteryPipeNoke,
    ContactInfoDialog,
    ServiceGuysComponent,
    ServiceGuyDialog,
    SecurityCheckInfoDialog,
    SecurityCheckDashboardComponent,
    InventoryStatus,
    ServiceGuyItemsDashboardComponent,
    ServiceGuysTypesViewComponent,
    UpdateStockDialog,
    ServiceGuyTypeDialog,
    PdfServiceDialog,
    EnumStatusPipe,
    ItemDialog,
    AssetsDashboardComponent,
    AssetInformationDialog,
    AddActionDialog,
    SelectServiceGuyDialog,
    TransferSummaryDialog,
    PerformedInspectionsComponent,
    DetachedBluetoothLocks,
    BluetoothLocks,
    RentalObjectListComponent,
    ServiceMessageDialogDialog
    ],
    imports: [
        T4CommonModule,
        T4coreModule,
        CommonModule,
        MatGridListModule,
        MatSortModule,
      RouterModule.forChild([
        {
          path: 'Maintenance',
          data: {
            index: 20000, title: "Maintenance", toolTip: "Maintainance", roles: ['BackOffice', 'Admin', 'LocationManager', 'GroupManager' , 'Production'], icon: 'construction'
          },
          canActivate: [AuthGuard],
          children: [
            { path: '', redirectTo: 'ServiceGuyIntro', pathMatch: 'full' },
            {
              path: "ServiceGuyIntro",
              data: { title: "ServiceGuys", icon: 'today', roles: ['BackOffice', 'Admin', 'Production'] },
              canActivate: [AuthGuard],
              children: [
                { path: '', redirectTo: 'ServiceGuys', pathMatch: 'full' },
                {
                  path: "ServiceGuys",
                  component: ServiceGuysComponent, 
                  data: { title: "ServiceGuys", icon: 'group', roles: ['BackOffice', 'Admin', 'Production'] }
                },
                {
                  path: "ServiceGuysTypes",
                  component: ServiceGuysTypesViewComponent, 
                  data: { title: "Types", icon: 'manage_accounts', roles: ['BackOffice', 'Admin'] }
                },
                {
                  path: "InventoryStatus",
                  canActivate: [AuthGuard],
                  component: InventoryStatus,
                  data: { title: " Inventory status", icon:'assignment_late',toolTip: "Inventory status list", roles: ['BackOffice'] }
                },
                {
                  path: "ServiceItems",
                  canActivate: [AuthGuard],
                  component: ServiceGuyItemsDashboardComponent,
                  data: { title: "Service Items", icon: 'home_repair_service',toolTip: "Service Items", roles: ['BackOffice'] }
                },
                {
                  path: "Assets",
                  canActivate: [AuthGuard],
                  component: AssetsDashboardComponent,
                  data: { title: "Assets", icon: 'inventory_2', toolTip: "ServiceGuys Assets", roles: ['BackOffice', 'Production'] }
                },
              ]
              },
              {
                path: "SecurityCheck",
                canActivate: [AuthGuard],
                component: SecurityCheckDashboardComponent,
                data: { title: "Security Checks", toolTip: "Security Check controll", roles: ['BackOffice'] }
            },
            {
              path: "RentalObjectLis",
              data: { title: "Trailers", icon: 'today', roles: ['BackOffice', 'Admin'] },
              children: [
                { path: '', redirectTo: 'Trailers', pathMatch: 'full' },
                {
                  path: "Trailers",
                  component: RentalObjectListComponent,
                  data: { title: "Trailers", icon: 'handyman', roles: ['BackOffice', 'Admin'] }
                }
              ]
            },
            {
              path: "Reports",
              data: { title: "Reports", icon: 'today', roles: ['BackOffice', 'Admin'] },
              children: [
                { path: '', redirectTo: 'Inspections', pathMatch: 'full' },
                {
                  path: "Inspections",
                  component: PerformedInspectionsComponent,
                  data: { title: "Inspections", icon: 'handyman', roles: ['BackOffice', 'Admin'] }
                },
                {
                  path: "Locks",
                  component: BluetoothLocks,
                  data: { title: "Locks", icon: 'lock', roles: ['BackOffice', 'Admin'] }
                }
                ,
                {
                  path: "DetachedLocks",
                  component: DetachedBluetoothLocks,
                  data: { title: "Detached locks", icon: 'lock_open_right', roles: ['BackOffice', 'Admin'] }
                }
              ]
            }
            ]
          }
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }],
    exports: [ServiceComponent]
})
export class ServiceModule { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Service.ServiceDialog", dialog: T4_ServiceDialog },
        { key: "T4.Service.ServiceGuyDialog", dialog: ServiceGuyDialog },
        { key: "T4.Service.SecurityCheckInfoDialog", dialog: SecurityCheckInfoDialog },
        { key: "T4.Service.updateStockDialog", dialog: UpdateStockDialog },
        { key: "T4.Service.ServiceGuyTypeDialog", dialog: ServiceGuyTypeDialog },

        { key: "T4.Service.ServiceGuyItemDialog", dialog: ItemDialog },
        { key: "T4.Service.assetInformationDialog", dialog: AssetInformationDialog },
        { key: "T4.Service.selectServiceGuy", dialog: SelectServiceGuyDialog },
        { key: "T4.Service.TransferSummary", dialog: TransferSummaryDialog },
        { key: "T4.Service.AddActionDialog", dialog: AddActionDialog },
        { key: "T4.Service.PdfServiceDialog", dialog: PdfServiceDialog },

        { key: "T4.Service.MesseageDialog", dialog: ServiceMessageDialogDialog }
      ]
    });
  };
}// Module initialization
